import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useLabels } from '../../../contexts/LabelsContext';
import StyledButton from '../../buttons/StyledButton';
import DrawStats from '../../partials/DrawStats';

import styles from '../../../../styles/themes/iga/iga-tablee-game-end.module.css';

interface IgaTableeGameEndProps {
    game: Game;
    participation: Participation;
    isValid: 'boolean';
    className?: string;
    children?: React.ReactNode;
}

function IgaTableeGameEnd({
    game,
    participation,
    isValid,
    className,
    children,
}: IgaTableeGameEndProps) {
    const url = useUrlGenerator();
    const {
        gameResultTitle = null,
        gameResultDescription = null,
        gameInvalidResultTitle = null,
    } = useLabels();
    const { draws = [] } = participation || {};
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                <div className={styles.header}>
                    <h4 className={styles.title}>
                        {isValid ? gameResultTitle : gameInvalidResultTitle}
                    </h4>
                    <div className={styles.description}>{gameResultDescription}</div>
                </div>
                <DrawStats draws={draws} className={styles.stats} />
                <StyledButton bordered href={url('account')} className={styles.button}>
                    <FormattedMessage defaultMessage="View my chances" description="Button label" />
                </StyledButton>
                <div className={styles.results}>
                    <h4 className={styles.title}>
                        <FormattedMessage
                            defaultMessage="Results Summary"
                            description="Game results title"
                        />
                    </h4>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default IgaTableeGameEnd;
